/**
 * Base de la API para fetch().
 * - En desarrollo: REACT_APP_API_BASE_URL o http://localhost:4000
 * - En producción: si la variable quedó en localhost (build equivocado o .env de dev),
 *   forzamos '' para que las URLs sean relativas al dominio (Nginx: /api → backend).
 */
function resolveApiBaseUrl() {
  const raw = (process.env.REACT_APP_API_BASE_URL || '').trim().replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    const isLocalHost =
      !raw ||
      /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\/?$/i.test(raw) ||
      /:\/\/localhost(:\d+)?(\/|$)/i.test(raw) ||
      /:\/\/127\.0\.0\.1(:\d+)?(\/|$)/i.test(raw);

    if (isLocalHost) {
      return '';
    }
    return raw;
  }

  return raw || 'http://localhost:4000';
}

export const API_BASE_URL = resolveApiBaseUrl();
export const CHATWOOT_EMBED_URL =
  process.env.REACT_APP_CHATWOOT_EMBED_URL ||
  'https://chat.farmagsa.com.ar/app/accounts/1/inbox-view';
export const CHATWOOT_ACCOUNT_NAME =
  (process.env.REACT_APP_CHATWOOT_ACCOUNT_NAME || '').trim() || 'Farmagsa';

// Cantidad de bloques/lotes a sincronizar en el login inicial.
// Valores posibles:
// - número (string) -> limita a esa cantidad de bloques
// - 'ALL' o vacío   -> sincroniza todos los bloques disponibles
export const INITIAL_SYNC_BLOCKS = process.env.REACT_APP_INITIAL_SYNC_BLOCKS || 'ALL';
